module.exports = __webpack_public_path__ + "img/montage-logo.75b430db.png";